import { render, staticRenderFns } from "./ModalBody.vue?vue&type=template&id=13df3591&scoped=true&"
import script from "./ModalBody.vue?vue&type=script&lang=ts&"
export * from "./ModalBody.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBody.vue?vue&type=style&index=0&id=13df3591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df3591",
  null
  
)

export default component.exports